module.exports = __webpack_public_path__ + "static/media/cyan-l.403f3faf.svg";